module.exports = __webpack_public_path__ + "static/media/logo-dark-fr.8b16f751.svg";